import { Button, createStyles, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';
import colors from '../../../../../themes/main-colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paperMobile: {
      margin: 0,
      bottom: 0,
      position: 'fixed',
      maxHeight: '90vh',
      width: '100%',
      maxWidth: 900,
    },
    buttonTwoContainer: {
      display: 'flex',
      gap: '15px',
      padding: '1rem 2rem',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column-reverse',
      },
    },
    buttonTwoContainerFirstButton: {
      width: '50%',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    buttonOne: {
      fontSize: 18,
      color: colors.sparkBlue,
      fontWeight: 600,
      '&:hover': {
        background: 'transparent',
      },
    },
    bottonOneContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: '2rem',
    },
    savePreferencesButton: {
      borderRadius: '20px',
      background: colors.orange,
      color: colors.white,
      fontSize: 18,
      fontWeight: 600,
      '&:hover': {
        backgroundColor: colors.orange,
        borderColor: colors.orange,
      },
    },
  }),
);

type CustomButtonProps = {
  buttonOneOnClick?: () => void;
  buttonTwoOnClick?: () => void;
  buttonOne?: string;
  buttonTwo?: React.ReactNode | string;
};

export function CustomButtons(props: CustomButtonProps) {
  const classes = useStyles();
  const { buttonOne, buttonTwo, buttonOneOnClick, buttonTwoOnClick } = props;

  return (
    <>
      {buttonTwo ? (
        <div className={classes.buttonTwoContainer}>
          <Button
            className={clsx(
              classes.buttonTwoContainerFirstButton,
              classes.buttonOne,
            )}
            onClick={buttonOneOnClick}
          >
            {buttonOne}
          </Button>
          <Button
            className={clsx(
              classes.savePreferencesButton,
              classes.buttonTwoContainerFirstButton,
            )}
            onClick={buttonTwoOnClick}
          >
            {buttonTwo}
          </Button>
        </div>
      ) : (
        <div className={classes.bottonOneContainer}>
          <Button className={classes.buttonOne} onClick={buttonOneOnClick}>
            {buttonOne}
          </Button>
        </div>
      )}
    </>
  );
}
